import React from 'react';

import { Button, Modal } from 'react-bootstrap';

function ConflictingReservationModal({ setPageLoaderStatus, showConflictingReservationModal, setShowConflictingReservationModal, removeReservationTime }) {

    const handleTryAgain = () => {
        removeReservationTime();
        setShowConflictingReservationModal(false);
        setPageLoaderStatus(false);
    }

    console.log('conflictingreservationmodal', showConflictingReservationModal);

    return (
        <div className="modalContainer">
            <Modal id="conflictingReservationModal" centered show={showConflictingReservationModal} onHide={handleTryAgain} backdrop="static" className="text-center">
                <Modal.Header className="text-center d-block">
                    <Modal.Title>Conflicting Reservation</Modal.Title>

                </Modal.Header>
                <>

                    <Modal.Body>
                        <p>We&apos;re sorry, but that time is no longer available.</p>


                    </Modal.Body>
                </>
                <Modal.Footer className="footerButtons">
                    <Button variant="danger" onClick={handleTryAgain}>
                        Try Again
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ConflictingReservationModal